export class CreateUserError extends Error {
  constructor(message) {
    super(message)
    this.name = 'CreateUserError'
    this.code = 'CREATE_USER_ERROR'
    this.title = 'Error al crear el usuario'
    this.message = 'No se pudo crear el usuario. Inténtalo nuevamente.'
  }
}
